import { getSignalingSocket } from 'services/signaling';
import { VirtualBackgroundUploadAcceptedPayload } from 'features/virtual-backgrounds/types';

interface RequestVirtualBackgroundUploadParams {
  name: string;
  fileSize: number;
}

export const requestVirtualBackgroundUpload = (
  params: RequestVirtualBackgroundUploadParams
): Promise<VirtualBackgroundUploadAcceptedPayload> =>
  getSignalingSocket().sendAsync<VirtualBackgroundUploadAcceptedPayload>({
    event: 'requestVirtualBackgroundUpload',
    data: {
      name: params.name,
      fileSize: params.fileSize,
    },
  });
